module.exports = __webpack_public_path__ + "static/media/award.9994fecd.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/award.png
// module id = 1138
// module chunks = 0